export const IDENTITY_LIFECYCLE_SIGNALS = {
	/** Stage 2 — marketing resonate (video, demo, waitlist page). */
	marketingResonateEngage: "marketing_resonate_engage",
	waitlistPageView: "waitlist_page_view",
	/** Stage 3 — high intent (pricing, CTAs, list signups, schedule chat). */
	pricingView: "pricing_view",
	highIntentCta: "high_intent_cta",
	waitlistSignup: "waitlist_signup",
	newsletterSignup: "newsletter_signup",
	scheduleChatBooked: "schedule_chat_booked",
	/** Stage 4 — authenticated account (registration or session established). */
	authSessionEstablished: "auth_session_established",
	/** Stage 5 — user onboarding complete (`onboardingComplete`). */
	onboardingCompleted: "onboarding_completed",
	/** Stage 5 — first app visit after onboarding (secondary latch). */
	postOnboardingAppVisit: "post_onboarding_app_visit",
} as const;

export type IdentityLifecycleSignal =
	(typeof IDENTITY_LIFECYCLE_SIGNALS)[keyof typeof IDENTITY_LIFECYCLE_SIGNALS];
